import { Injectable } from '@angular/core';
import {
  ICustomProperties,
  IDependencyTelemetry,
  IExceptionTelemetry,
  IMetricTelemetry,
  ITraceTelemetry,
} from '@microsoft/applicationinsights-web';

import { TelemetryService } from './telemetry.service';

@Injectable()
export class ServerTelemetryService extends TelemetryService {
  trackTrace(
    message: ITraceTelemetry,
    properties?: ICustomProperties,
  ): void {
    // No-op during SSR
    void message;
    void properties;
  }

  trackDependencyData(dependency: IDependencyTelemetry): void {
    // No-op during SSR
    void dependency;
  }

  trackMetric(
    metric: IMetricTelemetry,
    properties?: ICustomProperties,
  ): void {
    // No-op during SSR
    void metric;
    void properties;
  }

  trackException(
    exception: IExceptionTelemetry,
    properties?: ICustomProperties,
  ): void {
    // No-op during SSR
    void exception;
    void properties;
  }

  flush(): void {
    // No-op during SSR
  }
}
